import { ComponentProps, ForwardedRef, forwardRef } from 'react';
import type { VideoProvider } from '~/interfaces';
import isE2E from '~/modules/utils/isE2E';

import DailymotionEmbed from './DailymotionEmbed';
import GenericVideoPlayer from './Generic';
import OfflineVideoPlayer from './Offline';
import YoutubeVideoPlayer, { VideoPlayerRef } from './Youtube';

export type VideoPlayerProps = ComponentProps<typeof YoutubeVideoPlayer> & {
  provider?: VideoProvider;
};

const VideoPlayer = forwardRef((props: VideoPlayerProps, ref: ForwardedRef<VideoPlayerRef>) => {
  const useOffline = import.meta.env.VITE_APP_OFFLINE || isE2E();

  if (useOffline) {
    return <OfflineVideoPlayer {...props} ref={ref} />;
  }

  const provider = props.provider ?? 'youtube';

  if (provider === 'youtube') {
    return <YoutubeVideoPlayer {...props} ref={ref} />;
  }

  if (provider === 'dailymotion') {
    return <DailymotionEmbed {...props} ref={ref} />;
  }

  return <GenericVideoPlayer {...props} ref={ref} />;
});

export default VideoPlayer;

export { VideoState } from '~/modules/Elements/VideoPlayer/VideoState';
export type { VideoPlayerRef } from './Youtube';